export default function uniqueListBy<T extends Record<string, any>>(list: T[], discriminatorKey: keyof T): T[] {
  return [...new Map(list.map((elm) => [elm[discriminatorKey], elm])).values()];
}
